import Vue from "vue";
//模块功能：事件查询页面
export default Vue.extend({
    name: "event-info",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {}
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/event-info.vue
// module id = null
// module chunks = 